import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ServicedeskReportsHomePageEntrypointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const servicedeskReportsHomePageEntrypoint: EntryPoint<
	ServicedeskReportsHomePageEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<ServicedeskReportsHomePageEntrypointComponent>(
		/* webpackChunkName: "async-csm-reports-home-entrypoint" */ './ReportsHomePage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
